// @flow
import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import defaultTheme from './Steps.scss';
import { SizeEnum } from 'common/enums/UIEnums';

type Props = {
    theme: Object,
    className?: string,
    size?: string,
    steps?: ?Array<{
        id: string | number,
        name: string,
        subtitle?: string,
        index: number
    }>,
    currentStep?: ?number,
    showSteps: boolean
};

class Steps extends React.PureComponent<Props> {
    static defaultProps = { showSteps: true };
    render() {
        const {
            theme,
            steps,
            currentStep,
            showSteps,
            className,
            size
        } = this.props;
        const sizeClass = SizeEnum.getSizeClass({ size, theme });

        const currentStepValue =
            steps && steps.find(step => step.id === currentStep);
        const currentStepIndex =
            (currentStepValue && currentStepValue.index) || 0;
        return showSteps ? (
            <div
                className={classnames(className, theme.stepsWrap, {
                    [sizeClass]: sizeClass
                })}
            >
                {steps &&
                    steps.map(step => (
                        <div
                            key={step.id}
                            className={classnames(theme.step, {
                                [theme.current]: step.id === currentStep,
                                [theme.previous]: step.index < currentStepIndex
                            })}
                        >
                            <div className={theme.stepId}>{step.index}</div>
                            <div className={theme.stepNameWrap}>
                                <div className={theme.stepName}>
                                    {step.name}
                                </div>
                                {step.subtitle ? (
                                    <div className={theme.stepSubtitle}>
                                        {step.subtitle}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    ))}
            </div>
        ) : null;
    }
}

export default themr('Steps', defaultTheme)(Steps);
